const languages = Object.freeze({
  languages: {
    english: 'en',
    spanish: 'es',
    france: 'fr',
    china: 'cmn',
    korea: 'ko'
  }
})
const languagesIds = Object.freeze({
  languagesIds: {
    english: 0,
    spanish: 1,
    france: 2,
    chinaMandarin: 3,
    korea: 4
  }
})

const consts = Object.freeze({
  ...languages,
  ...languagesIds
})

export default consts
